import { removeObjectFromArrayByKey } from '@/utils/arrayUtils';

/**
 * This is used with mutating SWR data. It provides a way for
 * removing an item from a list of data.
 *
 * @example
 * mutate(
 *   key,
 *   (currentData: GetCampaignEventsData) =>
 *     removeItemFromListMutation({
 *       dataKey: 'ticketedEvents',
 *       idKey: 'ticketedEventId',
 *       currentData,
 *       item: updatedCampaignEvent,
 *     }),
 *   false
 * );
 *
 * @param dataKey key for the data on currentData
 * @param idKey key for the ID of the item being removed
 * @param item item being removed from the list
 * @param currentData mutation data
 */
export default function removeItemFromListMutation<
  DataKey extends string,
  IdKey extends string,
  Item extends {
    [key in IdKey]?: string;
  },
>({
  dataKey,
  idKey,
  itemId,
  currentData,
}: {
  dataKey: DataKey;
  idKey: IdKey;
  itemId: string;
  currentData: {
    [key in DataKey]: Item[];
  } & {
    totalHits: number;
  };
}) {
  if (!currentData[dataKey].find((item) => item[idKey] === itemId)) {
    return currentData;
  }

  return {
    ...currentData,
    [dataKey]: removeObjectFromArrayByKey(
      currentData[dataKey] || [],
      itemId,
      idKey,
    ),
    totalHits: (currentData?.totalHits || 1) - 1,
  };
}
